import React from "react";
import { Box, Stack, Typography } from "@mui/material";

interface SettingsSectionProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
}

export const SettingsSection: React.FC<SettingsSectionProps> = ({
  title,
  description,
  children,
}) => (
  <Stack spacing={2}>
    {(title || description) && (
      <Box>
        {title && (
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
    )}
    {children}
  </Stack>
);
